import { Settings } from 'lucide-react';
import type { ProductAttribute } from '../../types/products';

interface ProductAttributesProps {
  attributes: ProductAttribute[];
}

export function ProductAttributes({ attributes }: ProductAttributesProps) {
  if (attributes.length === 0) {
    return null;
  }

  // Group attributes by group_name
  const groupedAttributes = attributes.reduce((acc, attr) => {
    const group = attr.group_name || 'Spezifikationen';
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(attr);
    return acc;
  }, {} as Record<string, ProductAttribute[]>);

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 overflow-hidden">
      <div className="flex items-center gap-3 p-4 border-b border-gray-100 dark:border-slate-700">
        <div className="w-10 h-10 bg-gray-100 dark:bg-slate-700 rounded-xl flex items-center justify-center">
          <Settings className="w-5 h-5 text-gray-600 dark:text-slate-400" />
        </div>
        <h3 className="font-semibold text-[#1A1A1A] dark:text-white">Spezifikationen</h3>
      </div>

      <div className="divide-y divide-gray-100 dark:divide-slate-700">
        {Object.entries(groupedAttributes).map(([group, attrs]) => (
          <div key={group}>
            {Object.keys(groupedAttributes).length > 1 && (
              <div className="px-4 py-2 bg-gray-50 dark:bg-slate-700/50">
                <span className="text-xs font-medium text-[#6B6B6B] dark:text-slate-400 uppercase tracking-wider">
                  {group}
                </span>
              </div>
            )}
            {attrs.map((attr) => (
              <div key={attr.id} className="flex px-4 py-3">
                <span className="w-1/3 text-sm text-[#6B6B6B] dark:text-slate-400 flex-shrink-0">{attr.key}</span>
                <span className="flex-1 text-sm font-medium text-[#1A1A1A] dark:text-white">{attr.value}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
